import { useRef } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";
import CreateGroup from "./CreateGroup.jsx";

function MogrtGroup({
  isVisible,
  setIsVisible,
  useCepStorage,
  saveCepStorage,
  getCepStorage,
  optionsPath,
  selectedTag,
  buttonTags,
  generateButtonTags,
  category,
}) {
  const createGroupRef = useRef(null);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-light fa-folder-tree"></i>
          <div />
        </div>
        <div className="button-card__title">Create Group</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__tools-grid">
          <div
            onClick={() => handleClick("autoGroupMogrt")}
            className="resolution-tools__button"
          >
            <i class="fa-light fa-folder-tree"></i>
            <span>Auto</span>
          </div>
          <div
            className="resolution-tools__button"
            onClick={() => createGroupRef.current?.open()}
          >
            <i class="fa-light fa-hand"></i>
            <span>User</span>
          </div>
        </div>
        <CreateGroup ref={createGroupRef} />
      </div>
    </>
  );
}

export default MogrtGroup;
